import { authenticatedFetch } from './request';

export default async function getSpecialities(setErrorMessage) {
    const onError = () => setErrorMessage('No se puede obtener las especialidades.');
    return await authenticatedFetch('/specialty/getList', onError);
}
